import ReactPixel from "react-facebook-pixel";

export function sendEventPixel(event, payload) {
  ReactPixel.track(event, payload);
}
